import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { Observable } from 'rxjs';

interface PreviewEmailData {
  template: Observable<{ templateHTML: string }>;
}

@Component({
  template: `
    <div class="modal" *ngIf="this.data.template | async as preview">
      <button class="close" mat-icon-button (click)="closeDialog()"><mat-icon>close</mat-icon></button>
      <div class="preview-container">
        <iframe sandbox [srcdoc]="preview.templateHtml | iTrustThisHtml" #previewFrame></iframe>
      </div>
    </div>
  `,
  styleUrls: ['./preview-email-modal.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NgIf, MatButtonModule, MatDialogModule, MatIconModule, GalaxyPipesModule],
})
export class PreviewEmailModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PreviewEmailData,
    public dialogRef: MatDialogRef<PreviewEmailModalComponent>,
  ) {}
  closeDialog(): void {
    this.dialogRef.close();
  }
}
